export default "__VITE_ASSET__DoGGEp3h__"